import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CapAlertService} from '../extension/exceptions/cap-alert.service';
import {tap} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {CapAlertLevel} from '../extension/exceptions/cap-alert-level.enum';
import {DecimalHochkommaPipe} from "../../shared/pipes/simple/decimalHochkomma.pipe";

@Injectable()
export class SearchResponseInterceptor implements HttpInterceptor {

  constructor(public alertService: CapAlertService,
              private translate: TranslateService,
              private decimalHochkomma: DecimalHochkommaPipe) {

  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      tap(evt => {
        if (evt instanceof HttpResponse) {
          if (evt.body && evt.body.tooManyRecordsFound) {
            this.alertService.warning(this.translate.instant("MaximalResultWarningKeineEinschraenkung",
              {
                maxDisplayableRecords: evt.body.maxDisplayableRecords,
                recordsFound: this.decimalHochkomma.transform(evt.body.recordsFound)
              }), CapAlertLevel.CONTENT_HEADER, false);
          }
        }
      }));
  }
}
